class ForbiddenError extends Error {
    constructor(cause?: Error) {
        super("No tiene suficientes permisos para acceder a este recurso", {
            cause,
        });
    }
}

export { ForbiddenError };
